import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { getDrainSelector } from '../../procedures/drain/selectors/drain.selector'
import { IDrainState } from '../../procedures/drain/store/drain.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addDrainItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const drainState: IDrainState = yield select(getDrainSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const {
    pta,
    addToTimeline,
    key,
    time,
    date,
    assessedBy,
    comments,
    action,
    attempts,
    successfulAttempt,
    isEkgImport,
  } = drainState
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.DRAIN_PROCEDURE,
      action?.name || '',
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Drain',
      eventSubHeader: `By ${assessedBy?.name || ''}, Action: ${action?.name || ''},
        Attempts: ${attempts}, Success: ${successfulAttempt}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_DRAIN_PROCEDURE_ITEM,
      defaultHref: TabConstants.DRAIN_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addDrainItemSaga() {
  yield takeLatest([TimelineConstants.ADD_DRAIN_ITEM], addDrainItem)
}
